import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';

import DND, { DropListOptionWrapperProps, RenderPreviewOptions } from '.';

import useStyles from './style';

const DropListOptionWrapper: FC<PropsWithChildren<DropListOptionWrapperProps>> = ({
  idx,
  dndType,
  children,
  canDrop = true,
  onDragEnd,
}) => {
  const classes = useStyles();

  const dropProps = {
    renderPreview: ({ isActive }: RenderPreviewOptions<{}>) =>
      isActive ? <div className={classNames('dropLine', classes.dropLine)} /> : <></>,
    accept: [dndType],
    droppable: () => canDrop,
    className: 'asDropLine',
  };

  return (
    <>
      {idx === 0 ? (
        <DND.Drop
          onDrop={item => {
            const addedIndex = -1;
            const removedIndex = item.index;

            onDragEnd({
              addedIndex,
              removedIndex,
            });
          }}
          renderIdx={0}
          {...dropProps}
        />
      ) : null}
      {children}
      <DND.Drop
        onDrop={item =>
          onDragEnd({
            addedIndex: idx,
            removedIndex: item.index,
          })
        }
        renderIdx={idx + 1}
        {...dropProps}
      />
    </>
  );
};

export default DropListOptionWrapper;
